export { default } from './WishlistButton';